import { KycProvider } from '../enums'

export const kycProviderMap = {
  1: KycProvider.yes,
  2: KycProvider.yoti,
  3: KycProvider.yotiDocScan,
  4: KycProvider.sumsub,
}
